import React from 'react';
import proptypes from 'prop-types';
import {
  Skeleton,
  SkeletonBlock,
  SkeletonContent,
  SkeletonLine
} from '@one-thd/sui-atomic-components';

const { bool } = proptypes;

export const CompatibleAccessoriesLoader = (hideRequiredText) => {
  return (
    <div>
      {!hideRequiredText && (
        <Skeleton grow>
          <SkeletonLine variant="single" />
        </Skeleton>
      )}
      <Skeleton disablePadding="y" orientation="horizontal" grow>
        <SkeletonContent density="loose" disablePadding="x" initialSize="full">
          <SkeletonBlock aspect="wide" />
        </SkeletonContent>
        <SkeletonContent density="loose" disablePadding="x" initialSize="full">
          <SkeletonLine numberOfLines={3} />
        </SkeletonContent>
      </Skeleton>
    </div>
  );
};

CompatibleAccessoriesLoader.propTypes = {
  hideRequiredText: bool
};

CompatibleAccessoriesLoader.defaultProps = {
  hideRequiredText: false
};
